var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"age-legend"},[_c('span',{staticClass:"ringworm"},[_vm._v("R")]),_vm._v(" "),_vm._l((_vm.ages),function(age,index){return _c('span',{key:index},[_c('Age',{attrs:{"year":age.year}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac9cae5c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/AgeLegend.vue
// module id = 424
// module chunks = 0